import type { PropsWithChildren, Ref } from 'react';

export interface SkyScrollableAreaProps extends PropsWithChildren {
  /** Optional additional CSS classes for the container */
  className?: string;
  ref?: Ref<HTMLDivElement>;
}

/**
 * SkyScrollableArea
 *
 * Lightweight scrollable container with default styles.
 * Use ref to expose the inner div to hooks or parent components.
 */
export const SkyScrollableArea = ({
  children,
  className = '',
  ref = undefined,
}: SkyScrollableAreaProps) => {
  // Default classes ensure consistent scrollbar styling via native CSS utility 'sky-scrollbar'
  const defaultClasses = 'overflow-y-auto sky-scrollbar ';

  const paddingClass = className.includes('pr-') ? '' : 'pr-4 ';
  // If caller provides a max-h- utility, respect it; otherwise use default calc-based max height.
  const heightClass = className.includes('max-h-') ? '' : 'max-h-[calc(100vh-200px)] ';
  // Merge classes: default behavior + optional height + caller classes
  const mergedClassName = [defaultClasses, paddingClass, heightClass, className]
    .filter(Boolean)
    .join(' ');
  return (
    <div ref={ref} className={mergedClassName} style={{ WebkitOverflowScrolling: 'touch' }}>
      {children}
    </div>
  );
};
